<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EGJYdx/tc-custom/9781398446847.jpg?1705540767817" alt="This image is the cover for the book The Bear With A Sore Throat"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Bear With A Sore Throat
      </h1>
      <p class="bookDescription body article font2">
        <p>Clara enjoyed visiting her grandparent’s house, but she could not have foreseen what was to happen following a knock on the door by the local policeman. The news he brought would lead her on a bear hunt and Clara would have to think fast if she was to help everyone to stay calm and make a new friend.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Keith Ballard
      </h2>
      
      <p class="authorDescription body article">Keith Ballard was a teacher for over 30 years. He currently lives in the North West of England with his wife, Angela, and they have three grown-up children and two grandchildren. He has served as an ordained permanent deacon since 1994.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?35173947